import Product from 'redux/store';
import { FETCH_RATING_PRODUCT, FETCH_RATING_PRODUCT_SUCCESS, FETCH_RATING_PRODUCT_FAIL } from 'redux/Reducers/RatingProduct/RatingProductReducer';
import { premmiar } from '../clients';

export const SaveRating = (User, data) => {
  return premmiar(User).post('api/Rating', data)
}

// eslint-disable-next-line default-param-last
// TODO: Remover esse código daqui
const FetchRatingProduct = async (User, finallyCallback = () => { }, { sku }) => {
  Product.dispatch({ type: FETCH_RATING_PRODUCT, payload: { sku } });
  premmiar(User).get(`/api/RatingAverage/Average?identification=${sku}&type=1`).then((response) => {
    Product.dispatch({
      type: FETCH_RATING_PRODUCT_SUCCESS,
      payload: {
        sku,
        ...response,
      },
    });
  }).catch((e) => {
    Product.dispatch({
      type: FETCH_RATING_PRODUCT_FAIL, payload: { sku }, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchRatingProduct;
